const state = {
  queues: [],
  agentsCampaign: [],
  campaignsAgent: [],
  agents: [],
  dialogExten: false,
};

export default state;
